var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.developerEnabled
    ? _c("div", [
        _c("div", { staticClass: "config-panel" }, [
          _c("div", { staticClass: "tools-title" }, [
            _c(
              "span",
              {
                on: {
                  click: function($event) {
                    _vm.expanded = !_vm.expanded
                  }
                }
              },
              [_vm._v(" Developer Tools ")]
            ),
            _vm._v(" | "),
            _c(
              "span",
              {
                staticClass: "option",
                class: {
                  "active-off": _vm.isAnyEnable,
                  "active-on": !_vm.isAnyEnable
                },
                on: { click: _vm.toggleDebug }
              },
              [_vm._v(" All ")]
            )
          ]),
          _vm.expanded
            ? _c("div", [
                _c("div", { staticClass: "property" }, [
                  _c("div", { staticClass: "property-item property-name" }, [
                    _vm._v("Show Permissions")
                  ]),
                  _c("div", { staticClass: "property-item property-status" }, [
                    _c(
                      "span",
                      {
                        staticClass: "option",
                        class: {
                          "active-off": !_vm.showPermissions,
                          "active-on": _vm.showPermissions
                        },
                        on: { click: _vm.toggleShowPermissions }
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.showPermissions ? "On" : "Off") + " "
                        )
                      ]
                    )
                  ])
                ]),
                _c("div", { staticClass: "property" }, [
                  _c("div", { staticClass: "property-item property-name" }, [
                    _vm._v("Debug Mode API")
                  ]),
                  _c("div", { staticClass: "property-item property-status" }, [
                    _c(
                      "span",
                      {
                        staticClass: "option",
                        class: {
                          "active-off": !_vm.debugApi,
                          "active-on": _vm.debugApi
                        },
                        on: { click: _vm.toggleDebugApi }
                      },
                      [_vm._v(" " + _vm._s(_vm.debugApi ? "On" : "Off") + " ")]
                    )
                  ])
                ]),
                _c("div", { staticClass: "property" }, [
                  _c("div", { staticClass: "property-item property-name" }, [
                    _vm._v("Show API Requests")
                  ]),
                  _c("div", { staticClass: "property-item property-status" }, [
                    _c(
                      "span",
                      {
                        staticClass: "option",
                        class: {
                          "active-off": !_vm.showRequests,
                          "active-on": _vm.showRequests
                        },
                        on: { click: _vm.toggleShowRequests }
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.showRequests ? "On" : "Off") + " "
                        )
                      ]
                    )
                  ])
                ]),
                _c("div", { staticClass: "property" }, [
                  _c("div", { staticClass: "property-item property-name" }, [
                    _vm._v("Show API Responses")
                  ]),
                  _c("div", { staticClass: "property-item property-status" }, [
                    _c(
                      "span",
                      {
                        staticClass: "option",
                        class: {
                          "active-off": !_vm.showResponses,
                          "active-on": _vm.showResponses
                        },
                        on: { click: _vm.toggleShowResponses }
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.showRequests ? "On" : "Off") + " "
                        )
                      ]
                    )
                  ])
                ]),
                _c("div", { staticClass: "property" }, [
                  _c(
                    "div",
                    {
                      staticClass: "property-item property-name log-level-name"
                    },
                    [_vm._v("Log Level")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "property-item property-status log-level-status"
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "option disable-select",
                          class: {
                            "active-on": _vm.logLevel === "debug",
                            "text-muted": _vm.logLevel !== "debug"
                          },
                          on: {
                            click: function($event) {
                              return _vm.setLogLevel("debug")
                            }
                          }
                        },
                        [_vm._v(" Debug ")]
                      ),
                      _vm._v(" | "),
                      _c(
                        "span",
                        {
                          staticClass: "option disable-select",
                          class: {
                            "active-on": _vm.logLevel === "info",
                            "text-muted": _vm.logLevel !== "info"
                          },
                          on: {
                            click: function($event) {
                              return _vm.setLogLevel("info")
                            }
                          }
                        },
                        [_vm._v(" Info ")]
                      ),
                      _vm._v(" | "),
                      _c(
                        "span",
                        {
                          staticClass: "option disable-select",
                          class: {
                            "active-off": _vm.logLevel === "error",
                            "text-muted": _vm.logLevel !== "error"
                          },
                          on: {
                            click: function($event) {
                              return _vm.setLogLevel("error")
                            }
                          }
                        },
                        [_vm._v(" Error ")]
                      )
                    ]
                  )
                ])
              ])
            : _vm._e()
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }